<div class="subfieldTotal">
  <div class="subfieldTotal__inner">
    <section
      ppTooltip
      [ppTitle]="ppUnitTooltip"
      class="customFieldNumeric__unitWrapper"
      [class.subfieldTotal__unit--hidden]="!ppUnit"
      >
      <span class="customFieldNumeric__unit">
        {{ ppUnit }}
      </span>
    </section>

    <section
      class="subfieldTotal__value"
      [class.subfieldTotal__value--noUnit]="!ppUnit"
      [ppTitle]="ppIsLocked ? ('locked_by_admin' | ppTranslate) : null"
      ppTooltip
      >
      <div class="subfieldTotal__value--inner">{{ formattedValue }}</div>

      @if (!formattedValue) {
        <div
          class="subfieldTotal__value--inner placeholder-text"
          >
          {{ placeholder }}
        </div>
      }
    </section>
  </div>

  <div class="subfieldTotal__title">{{ 'total' | ppTranslate }}</div>
</div>
